import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function TypeBadge({ data, className }) {
    const { t } = useTranslation();
    const [type, setType] = useState(t("Скриншот"));
    const [typeVariant, setTypeVariant] = useState("success");

    useEffect(() => {
        if (data?.vkvideo_id) {
            setType(t("Видеофайл"));
            setTypeVariant("primary");
        } else if (data?.video) {
            setType(t("Ссылка"));
            setTypeVariant("info");
        }
    }, [data]);

    return (
        <Badge variant={typeVariant} className={className}>
            {type}
        </Badge>
    );
}

export default TypeBadge;
